import econLogoSilhouetteUrl from "../skin/brand/econ-logo-silhouette.png?url";
/**
 * Port of the original skin's `core/shell/chrome/logo-econ-mask.js` — points the topbar's
 * animated `.brand-econ-shine` gradient layer at a pre-baked transparent silhouette of the
 * Economy V1 wordmark instead of the baked-in white-background PNG, so the CSS mask
 * (`-webkit-mask-image`/`mask-image`, `.brand-econ-shine` in base.css) reveals the
 * `brandEconFlow` gradient through the actual glyph shape rather than a solid rectangle.
 *
 * The source used a `<canvas>` readback to build this silhouette at runtime, which throws a
 * `SecurityError` under `file://` (tainted canvas) — the source's own fix was to ship the
 * silhouette as a real asset and skip the readback entirely; this port does the same.
 *
 * base.css keys the shine's visible-on-hover transition off `.brand-econ-shine.ready`
 * (`.brand-econ-shine{opacity:0}` / `.ready{opacity:0}` / `:hover .ready{opacity:1}`), so the
 * class must be added once the mask is wired, mirroring the source's `mount()`.
 */
export function applyBrandEconShine(root) {
    const shines = root.querySelectorAll(".brand-econ-shine");
    for (const shine of shines) {
        shine.style.setProperty("-webkit-mask-image", `url(${econLogoSilhouetteUrl})`);
        shine.style.setProperty("mask-image", `url(${econLogoSilhouetteUrl})`);
        shine.classList.add("ready");
    }
}
//# sourceMappingURL=brand-shine.js.map